import api from './client';

export interface Parametros {
  id: number;
  cteMonitoramentoAtivo: boolean;
  reposicaoCalculosAtivos: boolean;
  reposicaoHorario: string;
  /** Liga/desliga o resumo diário da Reposição na Central de Notificações (Fase 2). */
  reposicaoDigestAtivo: boolean;
  metabaseUrl?: string | null;
  /** Janela padrão (em meses) da Reposição. Valores válidos: 1, 2, 3, 6, 9, 12. */
  janelaAnaliseMesesDefault: number;
  /** Retenção da auditoria (dias). 0 = manter para sempre; ligado, mínimo 7. */
  auditoriaRetencaoDias: number;
  /** Retenção do log técnico (dias). 0 = manter para sempre; ligado, mínimo 7. */
  logRetencaoDias: number;
  /** Retenção das notificações in-app (dias). 0 = manter para sempre; ligado, mínimo 7. */
  notificacaoRetencaoDias: number;
  /** Retenção da telemetria de uso (dias). 0 = manter para sempre; ligado, mínimo 7. */
  telemetriaRetencaoDias: number;
  /** Conferência de NF-e: permite XML vindo do manifesto (Distribuição DFe) como fonte, além do upload manual. */
  conferenciaPermiteManifesto: boolean;
  /** Conferência de NF-e: permite contagem manual (sem coletor) como método de conferência. */
  conferenciaContagemManual: boolean;
  /** Conferência de NF-e: liga o atalho de multiplicação na bipagem ("12*código"). */
  conferenciaMultiplicadorAtivo: boolean;
  atualizadoEm?: string;
}

export const parametrosApi = {
  obter: async (): Promise<Parametros> => {
    const r = await api.get<Parametros>('/parametros');
    return r.data;
  },
  salvar: async (dados: Parametros): Promise<void> => {
    await api.put('/parametros', dados);
  },
};
